webpackJsonp([25],{

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_lib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userDataValidation__ = __webpack_require__(881);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function getGenderName(id) {
	var _ref = Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["e" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["d" /* equality */])('id', id), this.genders) || {},
	    title = _ref.title;

	return title;
}

function getValue(route, user) {
	return Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["f" /* getDeeper */])(route)(user);
}

function departmentsHandler() {
	if (Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["g" /* isEmpty */])(this.departments)) {
		return '--';
	}

	var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["e" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["d" /* equality */])('id', this.user.provinceId), this.departments) || {},
	    name = _ref2.name;

	return name;
}

function districtsHandler() {
	if (Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["g" /* isEmpty */])(this.districts)) {
		return '--';
	}

	var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["e" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["d" /* equality */])('id', this.user.parishId), this.districts) || {},
	    name = _ref3.name;

	return name;
}

function provinceHandler() {
	if (Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["g" /* isEmpty */])(this.provinces)) {
		return '--';
	}

	var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["e" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["d" /* equality */])('id', this.user.cityId), this.provinces) || {},
	    name = _ref4.name;

	return name;
}

function labelCountry() {
	return Object(__WEBPACK_IMPORTED_MODULE_2__shared_lib__["f" /* getDeeper */])('company.country.countryCode')(this.user) === 'ECU' ? 'Cédula' : 'DNI';
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'user-data-details',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['departments', 'districts', 'genders', 'provinces', 'user']), {
		labelCountry: labelCountry
	}),
	mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_userDataValidation__["a" /* default */]],
	methods: {
		departmentsHandler: departmentsHandler,
		districtsHandler: districtsHandler,
		getGenderName: getGenderName,
		getValue: getValue,
		provinceHandler: provinceHandler
	},
	watch: {
		departments: departmentsHandler,
		districts: districtsHandler,
		provinces: provinceHandler
	}
});

/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(778)("719a1ebe", content, true, {});

/***/ }),

/***/ 1124:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(777)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi\"),url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}.info-container[data-v-3f0c95a2]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:grid;font-family:Avenir Next Medium;grid-column-gap:50px;grid-template-columns:1fr 1fr;margin:0 auto;width:280px}.label[data-v-3f0c95a2]{color:#acaaaa;display:block;font-size:12px}.user-content[data-v-3f0c95a2]{color:#4a4a4a;font-size:14px}", "", {"version":3,"sources":["/opt/build/repo/src/components/profile/user-data-details.vue"],"names":[],"mappings":"AACA,WAAW,gCAAkC,kBAAkB,gBAAmB,wGAAwG,CACzL,AACD,WAAW,+BAAiC,kBAAkB,gBAAmB,kGAAkG,CAClL,AACD,WAAW,oCAAsC,kBAAkB,gBAAmB,0GAA0G,CAC/L,AACD,WAAW,2CAA6C,kBAAkB,gBAAmB,mHAAmH,CAC/M,AACD,WAAW,+BAAiC,kBAAkB,gBAAmB,kHAAkH,CAClM,AACD,WAAW,sCAAwC,kBAAkB,gBAAmB,+GAA+G,CACtM,AACD,WAAW,6BAA+B,kBAAkB,gBAAmB,kGAAkG,CAChL,AACD,WAAW,oCAAsC,kBAAkB,gBAAmB,2GAA2G,CAChM,AACD,WAAW,6BAA+B,kBAAkB,gBAAmB,kGAAkG,CAChL,AACD,WAAW,8BAAgC,kBAAkB,gBAAmB,mGAAmG,CAClL,AACD,WAAW,qCAAuC,kBAAkB,gBAAmB,6GAA6G,CACnM,AACD,WAAW,6BAA+B,kBAAkB,gBAAmB,kFAAmF,CACjK,AACD,iCAAiC,wBAAwB,qBAAqB,uBAAuB,aAAa,+BAAiC,qBAAqB,8BAA8B,cAAc,WAAW,CAC9N,AACD,wBAAwB,cAAc,cAAc,cAAc,CACjE,AACD,+BAA+B,cAAc,cAAc,CAC1D","file":"user-data-details.vue","sourcesContent":["\n@font-face{font-family:\"Avenir Next Regular\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Ultra Light\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Ultra Light Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Medium\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Medium Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Demi\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Demi\"),url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Demi Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Bold\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Heavy\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Heavy Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Book\";font-style:normal;font-weight:normal;src:local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))\n}\n.info-container[data-v-3f0c95a2]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:grid;font-family:\"Avenir Next Medium\";grid-column-gap:50px;grid-template-columns:1fr 1fr;margin:0 auto;width:280px\n}\n.label[data-v-3f0c95a2]{color:#acaaaa;display:block;font-size:12px\n}\n.user-content[data-v-3f0c95a2]{color:#4a4a4a;font-size:14px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"info-container"},[_c('div',{staticClass:"col"},[_c('p',[_c('span',{staticClass:"label"},[_vm._v("Nombre:")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.user.name))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Apellidos:")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.user.lastname))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Género:")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.getGenderName(_vm.user.gender)))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Teléfono:")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.getValue('phone', _vm.user)))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.countryLabels.province)+":")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.provinceHandler()))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Correo:")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.getValue('email', _vm.user)))])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('p',[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.labelCountry)+":")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.getValue('typePerson.documentNumber', _vm.user)))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v("RUC:")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.getValue('ruc', _vm.user)))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Código postal:")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.getValue('postalCode', _vm.user)))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.countryLabels.department)+":")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.departmentsHandler()))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.countryLabels.district)+":")]),_vm._v(" "),_c('span',{staticClass:"user-content"},[_vm._v(_vm._s(_vm.districtsHandler()))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_data_details_vue__ = __webpack_require__(1010);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f0c95a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_data_details_vue__ = __webpack_require__(1125);
function injectStyle (ssrContext) {
  __webpack_require__(1123)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f0c95a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_data_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f0c95a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_data_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 881:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function onlyNumbers(val) {
	return Number(val) > 0;
}

function onlyCharacters(char) {
	if (char && char !== null) {
		var trimedChar = char.split(' ').join('');
		var noChar = /[^a-zA-ZáéíóúáéíóúÁÉÍÓÚñÑ]/i.test(trimedChar);
		return !noChar;
	}
	return false;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		onlyCharacters: onlyCharacters,
		onlyNumbers: onlyNumbers
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.d2613419f45b1a98fba6.js